import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yes-2--sprite",
  "use": "yes-2--sprite-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"yes-2--sprite\">\n<path d=\"M5.79508 10.8749L1.62508 6.70492L0.205078 8.11492L5.79508 13.7049L17.7951 1.70492L16.3851 0.294922L5.79508 10.8749Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol